import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Loader from "./Loader";
import axios from "../lib/AxiosGo";
import { toast } from "react-toastify";

const SignInLayer = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    email: "",
    password: "",
  });
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!data.email || !data.password) {
      toast.warning("Silakan isi Email/Username dan Password");
      return;
    }

    setLoading(true);
    axios
      .post("/auth", data)
      .then((response) => {
        localStorage.setItem("auth_token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));
        toast.success("Login berhasil! Selamat datang.");
        navigate("/devices");
      })
      .catch((error) => {
        console.error("Error submitting form:", error);
        const msg = error.response?.data?.message || "Login gagal, periksa email/username dan password Anda";
        toast.error(msg);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <section className="auth bg-base d-flex flex-wrap">
      <div className="auth-left d-lg-block d-none">
        <div className="d-flex align-items-center flex-column h-100 justify-content-center">
          <img src="assets/images/auth/logo-polisi.jpeg" alt="Logo Polda" style={{ maxHeight: '420px', objectFit: 'contain' }} />
        </div>
      </div>
      <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
        <div className="max-w-464-px mx-auto w-100">
          <div>
            <div className="text-center">
              <Link to="/" className="mb-40 max-w-290-px d-inline-block">
                <img src="assets/images/logo.png" alt="Logo" />
              </Link>
            </div>
            <h4 className="mb-12">Login Dashboard Polda</h4>
            <p className="mb-32 text-secondary-light text-base">
              Layanan Bot WhatsApp Pengaduan Masyarakat
            </p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="icon-field mb-16">
              <span className="icon top-50 translate-middle-y">
                <Icon icon="mage:email" />
              </span>
              <input
                type="text"
                className="form-control h-56-px bg-neutral-50 radius-12"
                placeholder="Email atau Username (polda@gmail.com)"
                value={data.email}
                onChange={(e) => setData({ ...data, email: e.target.value })}
                required
              />
            </div>
            <div className="position-relative mb-20">
              <div className="icon-field">
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="solar:lock-password-outline" />
                </span>
                <input
                  type="password"
                  className="form-control h-56-px bg-neutral-50 radius-12"
                  id="your-password"
                  placeholder="Password"
                  value={data.password}
                  onChange={(e) =>
                    setData({ ...data, password: e.target.value })
                  }
                  autoComplete="current-password"
                  required
                />
              </div>
            </div>
            <button
              type="submit"
              className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-24"
              disabled={loading}
            >
              {loading ? <Loader /> : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default SignInLayer;
